export default {"src":"/accounts/_next/static/media/Projects.5d2dbc39.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};